import { createFileRoute } from "@tanstack/react-router";
import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/admin/users/members/create")({
  component: () => (
    <MaskRedirect
      to="/admin/users/members"
      action="create"
      mask="/admin/users/members/create"
    />
  ),
});
